/**
 * @file Etiquetas bilingües `{ en, es }` del schema.
 * @module i18n
 */

/**
 * @param {unknown} value String o `{ en?: string, es?: string }`.
 * @param {"en" | "es"} locale
 * @returns {string}
 */
export function pickLocalized(value, locale) {
	if (value && typeof value === "object" && !Array.isArray(value)) {
		const o = value;
		if (typeof o[locale] === "string" && o[locale].length > 0) {
			return o[locale];
		}
		if (typeof o.en === "string" && o.en.length > 0) return o.en;
		if (typeof o.es === "string" && o.es.length > 0) return o.es;
		return "";
	}
	if (typeof value === "string") return value;
	return "";
}

/**
 * @param {Array<Record<string, unknown>>} sections
 * @param {"en" | "es"} locale
 * @returns {Record<string, string>}
 */
export function sectionTitlesById(sections, locale) {
	/** @type {Record<string, string>} */
	const out = {};
	for (const section of sections) {
		if (section.id) {
			out[section.id] = pickLocalized(section.title, locale);
		}
	}
	return out;
}
